import { render, staticRenderFns } from "./ExtraFormatSelectorDialog.vue?vue&type=template&id=786053a6&"
import script from "./ExtraFormatSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./ExtraFormatSelectorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports